export const maxWidth = '1600px';
export const primaryColor = 'rgb(147, 193, 196)';
export const textLight = '#f6f6f6';
export const textDark = '#191919';
export const darkBg = '#121417';
export const lightBg = '#f3f3f3';